var $7ce007695df59ab4$exports = {};
$7ce007695df59ab4$exports = {
    "colorFormat": `Formato da cor`,
    "hex": `Hexadecimal`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$7ce007695df59ab4$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
